let currentCategory = {
    name : '',
    parent : false
}
let originalCategoryRef;
let originalSubcategoriesRef;
let originalSubcategories;
let isNewCategory;
let hasSubcategories;
let originalCategory;

let newCategory = {}

const openCategoryForm = (name, parent, isNew) => {
    newCategory.categoryName = name;
    newCategory.parent = parent ? parent : 'false';
    originalCategory = name;
    openNewCategoryForm(name, parent)
    if (isNew === true){
        isNewCategory = true;
        originalSubcategoriesRef =  database.ref('categories/' + parent + '/' + name)
    } else {
        isNewCategory = false;
        if (parent === 'false' || parent === null) {
            originalSubcategoriesRef =  database.ref('categories/' + parent + '/' + name)
            originalCategoryRef =  database.ref('categories/' + name)
            originalCategoryRef.once('value', function(snapshot){
                originalSubcategories = snapshot.val();
                if (originalSubcategories === undefined) {
                    hasSubcategories = false
                     $('#parent').attr('disabled',false)
                } else {
                    hasSubcategories = true
                    $('#parent').attr('disabled',true)
                }
            })
        }
    }
}

const removeCategory = (name, parent) =>{
    if (parent === 'false' || parent === null){
        const categoryRef = database.ref('/categories/' + name.replace('---',''))
        categoryRef.remove().then(function(){
            getCategories()
        });;
    } else {
        console.log(name,parent)
        const categoryRef = database.ref('/categories/' + parent + '/subCategories/' + name.replace('---',''))
        categoryRef.remove().then(function(){
            getCategories()
        });
    }
}

const saveCategory = (name, parent) => {
    newCategory.parent = $('#parent').val();
    if (isNewCategory){
        if (newCategory.parent === 'false' || newCategory.parent === 'null'){
            let newCategoryRef = database.ref('/categories/' + newCategory.categoryName)
            newCategoryRef.set({subCategories : false})
            closeModal()
            getCategories()
        } else {
            let newCategoryRef = database.ref('/categories/' + newCategory.parent + '/subCategories/' + newCategory.categoryName)
            newCategoryRef.set(newCategory.categoryName)
            closeModal()
            getCategories()
        }
    } else {
        if (newCategory.parent === 'false' || newCategory.parent === 'null'){
            originalCategoryRef.remove();
            if (!hasSubcategories){
                let newCategoryRef = database.ref('/categories/' + newCategory.categoryName)
                newCategoryRef.set({subCategories : false})
            } else {
                let newCategoryRef = database.ref('/categories/' + newCategory.categoryName)
                newCategoryRef.set(originalSubcategories);
            }
            closeModal()
            getCategories()
        } else {
            let newCategoryRef = database.ref('/categories/' + newCategory.parent + '/subCategories/' + newCategory.categoryName.replace('---',''))
                console.log('/categories/' + newCategory.parent + '/subCategories/' + originalCategory)
                database.ref('/categories/' + newCategory.parent + '/subCategories/' + originalCategory.replace('---','')).remove()
                newCategoryRef.set((newCategory.categoryName).replace('---',''))
            closeModal()
            getCategories()
        }
    }
}

const categoryInput = (el) => {
    newCategory.parent = 'false';
    newCategory[$(el).attr('id')] = $(el).val();
    console.log(newCategory);
}

const openNewCategoryForm = (name, parent) => {
    $('.pent-modal').addClass('open');
    let modalContent = `
        <div class="admin-form">
            <div class="modal-content">
                <img
                    class="modal-close-button"
                    src="/assets/images/ui/close-button.png"
                    onClick="closeModal()"
                    >
                <h4 class="modal-title pt-3">Edit Categoria</h4>
                <div class="spacer" style="height: 70px"></div>
                <div class="modal-size-select pl-2 pr-2">
                    <div class="form-group">
                        <label for="category">Nome Categoria</label>
                        <input required type="text" value="${name ? name.replace('---','') : ''}" class="form-control" id="categoryName" aria-describedby="name" placeholder="Nome categoria" oninput="categoryInput(this)"/>
                    </div>
                    <div class="form-group">
                        <label for="sizeType">Categoria Padre</label>
                        <select value="${parent}" class="form-control" id="parent" oninput="categoryInput(this)">
                            <option class="default-select-opt" value="false">
                                ----nessuna----
                            </option>
                        </select>
                    </div>
                </div>
                <div class="addToCartButton pl-2 pr-2 pb-2">
                    <button class="w-100 formal" onClick="saveCategory('${name ? name : null}','${parent ? parent : null}')"><small>Salva</small></button>
                </div>
            </div>
        </div>
    `
    $('.pent-modal').append(modalContent);
    createCategoryOptions()
}
